const zIndex = 9999
const dropdownHeight = 35
const bufferSize = 3
const dropdownPlacementTopValue = dropdownHeight + bufferSize
const defaultSelectedFileType = 'Excel'
const defaultButtonLabel = 'Download'

export { zIndex, dropdownPlacementTopValue, defaultSelectedFileType, defaultButtonLabel }
